import React from 'react'

// 抽离图片样式常量
const beianImgStyle = {
  width: '16px',
  height: '16px',
  objectFit: 'contain',
  verticalAlign: 'middle',
  margin: '0 6px' // 替代 | 分隔符间距
}

const Footer = () => {
  // 图片加载失败隐藏
  const handleImgError = (e) => {
    e.target.style.display = 'none'
  }

  return (
    <footer>
      <section className="footer-logo">
        <svg 
          className="footer-logo-mini" 
          width="28" 
          height="28" 
          viewBox="0 0 72 72" 
          fill="none"
          aria-label="萝卜AI个人网logo"
          preserveAspectRatio="xMidYMid meet"
          overflow="hidden"
        >
          <circle cx="36" cy="36" r="34" fill="#0d1117" stroke="url(#footer-fBorder)" strokeWidth="1.5"/>
          <path d="M36 16C28 16 20 26 20 36C20 46 26 56 36 58C46 56 52 46 52 36C52 26 44 16 36 16Z" fill="url(#footer-fBody)"/>
          <path d="M30 16C26 8 18 7 16 12C14 17 20 20 26 17C24 22 22 26 24 28C26 24 30 20 30 16Z" fill="url(#footer-fLeaf)"/>
          <path d="M36 14C36 6 30 3 28 7C26 11 30 15 36 14Z" fill="url(#footer-fLeaf)"/>
          <path d="M42 16C46 8 54 7 56 12C58 17 52 20 46 17C48 22 50 26 48 28C46 24 42 20 42 16Z" fill="url(#footer-fLeaf)"/>
          <text x="36" y="47" textAnchor="middle" fontFamily="monospace" fontSize="11" fontWeight="700" fill="white" opacity=".9">AI</text>
          <defs>
            {/* 渐变ID加唯一前缀，避免全局冲突 */}
            <linearGradient id="footer-fBody" x1="36" y1="16" x2="36" y2="58" gradientUnits="userSpaceOnUse">
              <stop offset="0%" stopColor="#ff6b9d"/><stop offset="100%" stopColor="#cc2244"/>
            </linearGradient>
            <linearGradient id="footer-fLeaf" x1="0" y1="0" x2="0" y2="1">
              <stop offset="0%" stopColor="#52c788"/><stop offset="100%" stopColor="#2d9e60"/>
            </linearGradient>
            <linearGradient id="footer-fBorder" x1="0" y1="0" x2="72" y2="72" gradientUnits="userSpaceOnUse">
              <stop offset="0%" stopColor="#ff4d6d" stopOpacity=".5"/>
              <stop offset="100%" stopColor="#52c788" stopOpacity=".3"/>
            </linearGradient>
          </defs>
        </svg>
        <span className="footer-name">萝卜AI个人网</span>
      </section>

      <div className="footer-text">LUOBO · AI NAVIGATOR · 持续更新中 · MADE WITH &#10084;</div>

      <div className="footer-icp">
        <a 
          href="https://beian.miit.gov.cn/" 
          target="_blank" 
          rel="noopener noreferrer"
        >
          粤ICP备2026002286号-8
        </a>

        <img 
          src="/beian-icon.png" 
          alt="公安备案图标" 
          style={beianImgStyle} 
          onError={handleImgError}
        />

        <a 
          href="https://beian.mps.gov.cn/#/query/webSearch?code=44030002014100" 
          target="_blank"
          rel="noopener noreferrer"
        >
          粤公网安备44030002014100号
        </a>
      </div>
    </footer>
  )
}

export default Footer